import AnimateButton from "./@extended/AnimateButton";
import {Button} from "@mui/material";
import {LoginOutlined} from "@ant-design/icons";
import React from "react";

function XeroLoginButton(props){
  let getAuth = props.getAuth;
  return(
      <>
        <AnimateButton>
          <Button size="large"
                  onClick={() => getAuth()}
                  endIcon={<LoginOutlined />}
                  variant={"contained"}
                  >Xero Sign In
          </Button>
        </AnimateButton>
      </>
  )
}

export default XeroLoginButton;